import { Link, SquareArrowOutUpRight } from 'lucide-react'
import React, { useState } from 'react'
import UnauthorizedPage from '../../layouts/UnauthorizedPage'
import { RiVoiceAiFill } from "react-icons/ri";

const DeveloperHubDocumentation = ({serviceID, clientID}) => {
    const handleRedirect = (type) => {
        if (type === 'call') {
            window.open('https://candle-soprano-eed.notion.site/Anthropod-Batch-Async-API-Documentation-V2-Jun-2025-1f52f7bec73e80808201c16ecc6b46f6', '_blank')
        } else if (type === 'chat') {
            window.open('https://dramatic-eggnog-6c7.notion.site/Anthropod-Batch-Async-API-Documentation-Chat-V2-1e257c2974e080eab7ebf70320acb415', '_blank')
        } else if (type === 'embedded') {
            window.open('https://docs.google.com/document/d/1xdwHBU9YqUekzLFO5UOgHQJVJ7LoWZ0fio-clCbkTZY/edit?tab=t.0#heading=h.li321c6dp1l', '_blank')
        } else if(type === 'voice-agents') {
            window.open('https://docs.google.com/document/d/1-PSnvGW0XJkEsk48qOYfukuo8jWp5dj92fUZveWVm-o/edit?tab=t.0', '_blank')
        }
    }

    const [role] = useState(()=>{
        const userCookie = getCookie('dashboard_login_user_creds');
        if (userCookie) {
            const userData = JSON.parse(userCookie);
            const role = userData.role
            return role
        }
        return 'admin';
    })

    function getCookie(name) {
        function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
        var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
        return match ? match[1] : null;
    }
  return (
    <div className="min-h-screen bg-gray-50 py-3 px-5 font-sans">
      {(role === 'admin' || role === 'superadmin') && <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-1 gap-6">

          {/* Main Content */}
          <div className="lg:col-span-3 space-y-8">
            
            {/* Application Section */}
            <div>
              <div className='mb-8'>
                <h1 className="text-xl font-semibold text-gray-900 mb-2"><span className='text-gray-500'>Developer Hub &gt;</span><span className='text-gray-900'> Documentation</span></h1>
                <p className="text-gray-500 text-sm">Find documentation for our APIs</p>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Call Analytics Card */}
                <div className="bg-white rounded-lg shadow-sm border p-6 hover:shadow-md transition-shadow flex justify-between items-center">
                  <div className="flex items-center">
                    <div className="w-8 h-8 rounded-lg flex items-center justify-center mr-3">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                      </svg>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900">Call Analytics</h3>
                  </div>
                  <SquareArrowOutUpRight onClick={()=>handleRedirect('call')} className='w-4 h-4 cursor-pointer' />
                </div>

                {/* Chat Analytics Card */}
                <div className="bg-white rounded-lg shadow-sm border p-6 hover:shadow-md transition-shadow flex justify-between items-center">
                  <div className="flex items-center">
                    <div className="w-8 h-8 rounded-lg flex items-center justify-center mr-3">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                      </svg>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900">Chat Analytics</h3>
                  </div>
                  <SquareArrowOutUpRight onClick={()=>handleRedirect('chat')} className='w-4 h-4 cursor-pointer' />
                </div>

                {/* Embedded Urls Card */}
                <div className="bg-white rounded-lg shadow-sm border p-6 hover:shadow-md transition-shadow flex justify-between items-center">
                  <div className="flex items-center">
                    <div className="w-8 h-8 rounded-lg flex items-center justify-center mr-3">
                    <Link className="w-5 h-5" />
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900">Embedded Urls</h3>
                  </div>
                    <SquareArrowOutUpRight onClick={()=>handleRedirect('embedded')} className='w-4 h-4 cursor-pointer' />
                </div>

                {/* Voice Agents Card */}
                <div className="bg-white rounded-lg shadow-sm border p-6 hover:shadow-md transition-shadow flex justify-between items-center">
                  <div className="flex items-center">
                    <div className="w-8 h-8 rounded-lg flex items-center justify-center mr-3">
                    <RiVoiceAiFill className="w-5 h-5" />
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900">Voice Agents</h3>
                  </div>
                  <SquareArrowOutUpRight onClick={()=>handleRedirect('voice-agents')} className='w-4 h-4 cursor-pointer' />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>}
      { (role === 'employee' || role === 'manager') && (
        <UnauthorizedPage/>)
      }
    </div>
  )
}

export default DeveloperHubDocumentation;